import script from "./HeroComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HeroComponent.vue?vue&type=style&index=0&id=ffaa9b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffaa9b5c"]])

export default __exports__